import dayjs from "dayjs";
import React, { FC } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, DatePicker } from "@pd/pd-ui-kit";
import { get } from "lodash";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetLocationData } from "~/hooks/locationData";
import {
  ContractType,
  DealersLocationItem,
  useGetDealersLocationItemQuery,
  useGetTemplatesQuery,
  useGibddSetMutation,
} from "~/schemas/generated/graphql";
import { Field } from "~/shared/ui/Field";

import s from "./styles.less";

interface IProps {
  setCloseModal?: () => void;
  gibdd?;
  refetch?;
}

const CreateGIBDDForm: FC<IProps> = ({ setCloseModal, refetch, gibdd }) => {
  const { t } = useTranslation();
  const { event, currentId } = useGetLocationData();
  const language = localStorage.getItem("language");
  const isEn = language === "en";
  const [createReport] = useGibddSetMutation({
    onCompleted() {
      setCloseModal();
      refetch();
    },
  });

  const { data, loading } = useGetTemplatesQuery({
    variables: {
      // count: 999,
      getAll: true,
      page: 0,
      type: ContractType[event],
    },
  });

  const selectGetTemplates = get(
    data,
    "DealerRegistryGetter.getTemplates.items",
    [],
  ).map((el) => {
    return {
      value: el.id,
      label: el.name,
    };
  });

  const diealerCity = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["City"],
    },
  });

  const selectCity = get(
    diealerCity,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  const diealerSubject = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["Subject"],
    },
  });

  const selectSubject = get(
    diealerSubject,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  const diealerFO = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["Fo"],
    },
  });

  const selectFO = get(
    diealerFO,
    `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  ).map((el) => {
    return {
      label: el,
      value: el,
    };
  });

  const { handleSubmit, control, watch, setValue, errors } = useForm({
    defaultValues: {
      ...gibdd,
      dateRegistration: new Date(gibdd?.dateRegistrationForm),
      city: { value: gibdd?.city, label: gibdd?.city },
      district: { value: gibdd?.district, label: gibdd?.district },
      federalArea: { value: gibdd?.federalArea, label: gibdd?.federalArea },
    },
  });

  const onSubmit = (data) => {
    createReport({
      variables: {
        id: currentId,
        vin: data.vin,
        dateRegistration: new Date(data.dateRegistration),
        city: data.city?.value,
        district: data.district?.value,
        region: data.district?.value,
        federalArea: data.federalArea?.value,
      },
    });
  };

  return (
    <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
      <ul>
        <li>
          <Field
            type="input"
            name="vin"
            control={control}
            label={t(`gibdd.vin`)}
          />
        </li>
        <li>
          <span>{t("gibdd.dateRegistration")}</span>
          <Controller
            name="dateRegistration"
            control={control}
            render={({ value, onChange }) => (
              <DatePicker
                className={s.date_picker_width}
                value={value ? dayjs(value) : null}
                onChange={(d) => onChange(d ? d.toDate() : null)}
                format="DD.MM.YYYY"
              />
            )}
          />
        </li>
        <li>
          <Field
            type="select"
            name="city"
            label={t("gibdd.city")}
            control={control}
            options={selectCity}
            labelInValue
            wrapperClassName={s.width_select}
          />
        </li>
        <li>
          <Field
            type="select"
            name="district"
            label={t("gibdd.district")}
            control={control}
            options={selectSubject}
            labelInValue
            wrapperClassName={s.width_select}
          />
        </li>
        <li>
          <Field
            type="select"
            name="federalArea"
            label={t("gibdd.federalArea")}
            control={control}
            options={selectFO}
            labelInValue
            wrapperClassName={s.width_select}
          />
        </li>
      </ul>

      <div className={s.btns}>
        <Button htmlType="submit">{t("ui.save")}</Button>
        <Button variant="outlined" onClick={setCloseModal}>
          {t("ui.close")}
        </Button>
      </div>
    </form>
  );
};
export default CreateGIBDDForm;
